import React from 'react';
import { Container } from './styled';
import { Icon } from '@/presentation/components';
import EnrollmentTurnAlertProps from './types';

const EnrollmentTurnAlert = ({
  enrollmentTurn,
  isMobile
}: EnrollmentTurnAlertProps) => {
  const { textDate = '', textHour = '', periodDesc = '' } = enrollmentTurn;
  return (
    <Container data-testid="cmp-enrollment-turn-alert" isMobile={isMobile}>
      <Icon name="calendar" size={24} />
      <p>
        Tu turno de matrícula de {periodDesc} inicia:{' '}
        <span>
          {`${(textDate.split(',')[1] ?? '').trim()} a las ${textHour
            .replace('hrs', '')
            .trim()}`}
        </span>
      </p>
    </Container>
  );
};

export default EnrollmentTurnAlert;
